// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__2CjpG","gradient":"loading_gradient__u6EwY"};